export default __webpack_public_path__ + "static/media/freddy.93d5ce9c.jpg";